import { Popconfirm, Space, Switch, Tag, Tooltip } from "antd"
import { Button } from "src/components/actions/button"
import { PencilSvg, TrashSvg } from "src/components/Svg"

export function getColumns(onEdit, onDelete, onToggleActive) {
  return [
    {
      title: "Позиция",
      dataIndex: "sortWeight",
      key: "sortWeight",
      sorter: (a, b) => a.sortWeight - b.sortWeight,
      defaultSortOrder: "ascend",
    },
    {
      title: "Название",
      dataIndex: "nameRu",
      key: "nameRu",
      sorter: (a, b) => String(a.nameRu).localeCompare(String(b.nameRu), "ru"),
    },
    {
      title: "Тип",
      dataIndex: "type",
      key: "type",
      render: (type) => <Tag>{type}</Tag>,
    },
    {
      title: "Ссылка",
      dataIndex: "link",
      key: "link",
      render: (link) => link || "—",
    },
    {
      title: "Показывать",
      dataIndex: "isActive",
      key: "isActive",
      render: (isActive, record) => (
        <Switch
          checked={isActive}
          disabled={!onToggleActive}
          onChange={(checked) => onToggleActive?.(record.id, checked)}
        />
      ),
    },
    {
      title: "Приложение",
      dataIndex: "showInMobile",
      key: "showInMobile",
      render: (showInMobile) =>
        showInMobile ? <Tag color="green">да</Tag> : <Tag>нет</Tag>,
    },
    {
      title: "Сайт",
      dataIndex: "showInSite",
      key: "showInSite",
      render: (showInSite) =>
        showInSite ? <Tag color="green">да</Tag> : <Tag>нет</Tag>,
    },
    ...(onEdit || onDelete
      ? [
          {
            title: "Действие",
            key: "action",
            render: (_, record) => (
              <Space size="small">
                {onEdit && (
                  <Tooltip
                    placement="top"
                    title="Редактировать"
                    mouseLeaveDelay={0}
                  >
                    <Button
                      size="small"
                      type="link"
                      onClick={() => onEdit(record.id)}
                    >
                      <PencilSvg />
                    </Button>
                  </Tooltip>
                )}
                {onDelete && (
                  <Tooltip placement="top" title="Удалить" mouseLeaveDelay={0}>
                    <Popconfirm
                      placement="left"
                      title="Действительно хотите удалить?"
                      onConfirm={() => onDelete(record.id)}
                      onCancel={stopPropagation}
                    >
                      <Button size="small" type="link" onClick={stopPropagation}>
                        <TrashSvg />
                      </Button>
                    </Popconfirm>
                  </Tooltip>
                )}
              </Space>
            ),
          },
        ]
      : []),
  ]
}

const stopPropagation = (e) => {
  e?.stopPropagation()
}
